export default "/images/17 Step3TakeAction-Consultant-To monitor progress-02.png?012a07554be6db123b8306534f6ef812";